export default __webpack_public_path__ + "static/media/infoIconSmall.3fffd2d9.svg";